import { render, staticRenderFns } from "./old_question.vue?vue&type=template&id=5973ec51&scoped=true&"
import script from "./old_question.vue?vue&type=script&lang=js&"
export * from "./old_question.vue?vue&type=script&lang=js&"
import style0 from "./old_question.vue?vue&type=style&index=0&id=5973ec51&lang=scss&scoped=true&"
import style1 from "./old_question.vue?vue&type=style&index=1&id=5973ec51&lang=scss&scoped=true&"
import style2 from "./old_question.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5973ec51",
  null
  
)

export default component.exports